import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Image from '../AppImage';
import Button from './Button';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  const navigationItems = [
  { name: 'Accueil', path: '/homepage', icon: 'Home' },
  {
    name: 'Nos Services',
    path: '/services',
    icon: 'Wrench',
    dropdown: [
    { name: 'Formations Professionnelles', path: '/professional-training-services' },
    { name: 'Conseil Stratégique', path: '/strategic-consulting-services' },
    { name: 'Organisation de Conférences', path: '/conference-organization-services' },
    { name: 'Études & Recherche', path: '/research-studies-services' }]

  },
  {
    name: 'Domaines d\'Expertise',
    path: '/expertise',
    icon: 'Award',
    dropdown: [
    { name: 'Formation & Développement', path: '/training-development-hub' },
    { name: 'Marketing Digital', path: '/digital-marketing-services' },
    { name: 'Intelligence Artificielle (IA)', path: '/ai-solutions-integration-hub' },
    { name: 'Management de Projets Numériques', path: '/digital-project-management-services' },
    { name: 'Management des Ressources Humaines', path: '/human-resources-management-services' },
    { name: 'Business Thérapie', path: '/business-therapy-services' }]

  },
  {
    name: 'À Propos',
    path: '/about',
    icon: 'Info',
    dropdown: [
    { name: 'Notre Histoire, Vision & Équipe', path: '/about/company-overview' },
    { name: 'Blog, Certifications & Partenaires', path: '/about/resources' }]

  },
  { name: 'Contact', path: '/contact', icon: 'Phone' }];


  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleDropdownToggle = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b-2 border-[#9B8E57]/20 shadow-md">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          {/* Main Header */}
          <div className="flex items-center justify-between h-20">
            {/* Logo Section - Compact */}
            <Link to="/homepage" className="flex items-center space-x-3 flex-shrink-0 group">
              <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-white to-gray-50 rounded-lg p-2 shadow-sm group-hover:shadow-md transition-all duration-300">
                <Image
                  src="/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png"
                  alt="CRF PERFECTION logo featuring interlocking heart-shaped design in red and gold colors representing Centre de Recherche et de Formation automotive excellence"
                  className="w-full h-full object-contain" />

              </div>
              <div className="hidden xl:block border-l-2 border-[#9B8E57]/30 pl-3">
                <h1 className="text-lg font-bold text-[#96121D] tracking-tight leading-tight">
                  CRF PERFECTION
                </h1>
                <p className="text-xs text-[#9B8E57] font-medium">Excellence & Formation</p>
              </div>
            </Link>

            {/* Desktop Navigation - Optimized Spacing */}
            <nav className="hidden lg:flex items-center space-x-6 ml-8 flex-1 justify-center">
              {navigationItems?.map((item, index) =>
              <div key={item?.name} className="relative">
                  {item?.dropdown ?
                <div className="relative group">
                      <button
                    className="flex items-center space-x-1 px-3 py-2 text-sm text-gray-700 hover:text-[#96121D] font-semibold transition-all duration-200 whitespace-nowrap border-b-2 border-transparent hover:border-[#9B8E57]"
                    onMouseEnter={() => setActiveDropdown(index)}
                    onMouseLeave={() => setActiveDropdown(null)}>

                        <span>{item?.name}</span>
                        <Icon name="ChevronDown" size={14} className="text-[#9B8E57] transition-transform duration-200" />
                      </button>
                      
                      {/* Dropdown Menu */}
                      <div
                    className={`absolute left-0 top-full mt-2 w-72 bg-white rounded-xl shadow-2xl border-2 border-[#9B8E57]/20 transition-all duration-200 ${
                    activeDropdown === index ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-2'}`
                    }
                    onMouseEnter={() => setActiveDropdown(index)}
                    onMouseLeave={() => setActiveDropdown(null)}>

                        <div className="py-2">
                          {item?.dropdown?.map((dropdownItem) =>
                      <Link
                        key={dropdownItem?.name}
                        to={dropdownItem?.path}
                        className="flex items-center px-4 py-2.5 text-gray-700 hover:bg-gradient-to-r hover:from-[#96121D]/5 hover:to-[#9B8E57]/5 hover:text-[#96121D] transition-all duration-200 border-l-3 border-transparent hover:border-[#9B8E57]">

                              <span className="text-sm font-medium">{dropdownItem?.name}</span>
                            </Link>
                      )}
                        </div>
                      </div>
                    </div> :

                <Link
                  to={item?.path}
                  className={`px-3 py-2 text-sm font-semibold transition-all duration-200 whitespace-nowrap border-b-2 ${
                  isActivePath(item?.path) ?
                  'text-[#96121D] border-[#9B8E57]' :
                  'text-gray-700 border-transparent hover:text-[#96121D] hover:border-[#9B8E57]'}`
                  }>

                      {item?.name}
                    </Link>
                }
                </div>
              )}
            </nav>

            {/* Search and CTA - Compact */}
            <div className="hidden md:flex items-center space-x-3 flex-shrink-0">
              {/* Search - Icon Only on Medium Screens */}
              <button className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-[#96121D] transition-colors duration-200 group">
                <Icon name="Search" size={18} className="group-hover:text-[#9B8E57]" />
                <span className="text-sm font-semibold hidden xl:inline">Recherche</span>
              </button>
              
              {/* Contact Button - Compact */}
              









            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 rounded-lg text-gray-600 hover:text-[#96121D] hover:bg-[#9B8E57]/10 transition-colors duration-200 border-2 border-transparent hover:border-[#9B8E57]/30"
              aria-label="Toggle mobile menu">

              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={22} />
            </button>
          </div>

          {/* Mobile Menu - Brand Colors */}
          {isMobileMenuOpen &&
          <div className="lg:hidden bg-gradient-to-b from-white to-gray-50 border-t-2 border-[#9B8E57]/20 shadow-xl">
              <div className="px-6 py-8 space-y-4">
                {/* Mobile Navigation */}
                {navigationItems?.map((item, index) =>
              <div key={item?.name}>
                    {item?.dropdown ?
                <div>
                        <button
                    onClick={() => handleDropdownToggle(index)}
                    className="flex items-center justify-between w-full px-5 py-4 text-left text-gray-700 hover:text-[#96121D] hover:bg-gradient-to-r hover:from-[#96121D]/5 hover:to-[#9B8E57]/5 rounded-xl transition-all duration-200 border-2 border-transparent hover:border-[#9B8E57]/30">

                          <div className="flex items-center space-x-4">
                            <div className="w-8 h-8 flex items-center justify-center bg-[#9B8E57]/10 rounded-lg">
                              <Icon name={item?.icon} size={18} className="text-[#96121D]" />
                            </div>
                            <span className="font-semibold">{item?.name}</span>
                          </div>
                          <Icon
                      name="ChevronDown"
                      size={18}
                      className={`text-[#9B8E57] transition-transform duration-200 ${
                      activeDropdown === index ? 'rotate-180' : ''}`
                      } />

                        </button>
                        
                        {activeDropdown === index &&
                  <div className="mt-3 ml-12 space-y-2">
                            {item?.dropdown?.map((dropdownItem) =>
                    <Link
                      key={dropdownItem?.name}
                      to={dropdownItem?.path}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="block px-5 py-3 text-sm text-gray-600 hover:text-[#96121D] hover:bg-[#9B8E57]/10 rounded-lg transition-colors duration-150 border-l-3 border-transparent hover:border-[#9B8E57]">

                                {dropdownItem?.name}
                              </Link>
                    )}
                          </div>
                  }
                      </div> :

                <Link
                  to={item?.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`flex items-center space-x-4 px-5 py-4 rounded-xl font-semibold transition-all duration-200 border-2 ${
                  isActivePath(item?.path) ?
                  'bg-gradient-to-r from-[#96121D]/10 to-[#9B8E57]/10 text-[#96121D] border-[#9B8E57]/30' :
                  'text-gray-700 hover:text-[#96121D] hover:bg-gradient-to-r hover:from-[#96121D]/5 hover:to-[#9B8E57]/5 border-transparent hover:border-[#9B8E57]/30'}`
                  }>

                        <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                  isActivePath(item?.path) ? 'bg-[#96121D] text-white' : 'bg-[#9B8E57]/10 text-[#96121D]'}`
                  }>
                          <Icon name={item?.icon} size={18} />
                        </div>
                        <span>{item?.name}</span>
                      </Link>
                }
                  </div>
              )}
                
                {/* Mobile Search and Contact */}
                <div className="pt-6 border-t-2 border-[#9B8E57]/20 space-y-4">
                  <button className="flex items-center space-x-4 w-full px-5 py-4 text-gray-600 hover:text-[#96121D] hover:bg-[#9B8E57]/10 rounded-xl transition-all duration-200 border-2 border-transparent hover:border-[#9B8E57]/30">
                    <div className="w-8 h-8 flex items-center justify-center bg-[#9B8E57]/10 rounded-lg">
                      <Icon name="Search" size={18} className="text-[#96121D]" />
                    </div>
                    <span className="font-semibold">Recherche</span>
                  </button>
                  
                  <Button
                  variant="default"
                  fullWidth
                  className="bg-gradient-to-r from-[#96121D] to-[#96121D]/90 hover:from-[#96121D]/90 hover:to-[#96121D] text-white rounded-xl font-semibold py-4 shadow-lg border-2 border-[#9B8E57]/30 hover:scale-105 transition-all duration-300">

                    <span className="flex items-center justify-center space-x-2">
                      <span>Contact</span>
                      <Icon name="ArrowRight" size={18} />
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          }
        </div>
      </header>
    </>);

};

export default Header;